import axios from 'axios';

class FetchService {
    constructor(config, updateInSec) {
        this.state = {
            config,
            updateInSec,
            successCallback: null,
            errorCallback: null,
            beforeFetch: null,
            afterFetch: null,
            hasSubscriber: false,
        };
        this.timeoutId = null;
        this.source = null;
    }

    subscribe(successCallback, beforeFetch, afterFetch, errorCallback) {
        this.state.hasSubscriber = true;
        this.state.successCallback = successCallback;
        this.state.beforeFetch = beforeFetch;
        this.state.afterFetch = afterFetch;
        this.state.errorCallback = errorCallback;

        this._fetch();

        return () => {
            this._cancelSubscribe();
        };
    }

    //setConfig(config) {
    //    this.state.config = config;
    //}

    //setParams() {}

    _fetch() {
        const { config } = this.state;

        this.source = axios.CancelToken.source();

        if (this.state.beforeFetch) {
            this.state.beforeFetch();
        }

        const newConfig = { ...config, cancelToken: this.source.token };

        axios(newConfig)
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                    return;
                }

                if (this.state.errorCallback) {
                    this.state.errorCallback(thrown);
                }

                this._fixedFetch();
            })
            .then((response) => {
                try {
                    if (this.state.successCallback) {
                        this.state.successCallback(response.data);
                    }
                } catch {
                    // TODO: call global error handler
                }

                this._fixedFetch();
            })
            .finally(() => {
                if (this.state.afterFetch) {
                    this.state.afterFetch();
                }
            });
    }

    _fixedFetch() {
        const { updateInSec } = this.state;

        this.timeoutId = setTimeout(this._fetch.bind(this), updateInSec * 1000);
    }

    _cancelSubscribe() {
        clearTimeout(this.timeoutId);
        this.state.hasSubscriber = false;
        this.state.successCallback = null;
        this.state.beforeFetch = null;
        this.state.afterFetch = null;
        this.state.errorCallback = null;
        this.source.cancel();
        this.source = null;
    }
}

export default FetchService;
